import React from "react";
import { Link } from "react-router-dom";

/**
 * UserMenuDropdown - Dropdown menu for user actions
 *
 * @param {Object} props
 * @param {Object} props.user - User data
 * @param {boolean} props.isOpen - Is dropdown open
 * @param {function} props.onClose - Close dropdown handler
 * @param {function} props.onSignOut - Sign out handler
 */
const UserMenuDropdown = ({ user, isOpen, onClose, onSignOut }) => {
  if (!isOpen || !user) return null;

  return (
    <div className="absolute right-0 mt-2 w-48 bg-[--elita-secondary] rounded-md shadow-lg z-10 py-1 border border-gray-700">
      <div className="px-4 py-2 border-b border-gray-700">
        <p className="text-sm text-white font-medium">
          {user.fullName || user.username}
        </p>
        <p className="text-xs text-gray-400 truncate">
          {user.emailAddresses?.[0]?.emailAddress || user.email}
        </p>
      </div>

      <Link
        to="/account"
        className="block px-4 py-2 text-sm text-gray-300 hover:bg-[--elita-secondary-hover] hover:text-white transition-colors duration-150 ease-in-out"
        onClick={onClose}
      >
        Account Settings
      </Link>

      <button
        onClick={onSignOut}
        className="block w-full text-left px-4 py-2 text-sm text-gray-300 hover:bg-[--elita-secondary-hover] hover:text-white transition-colors duration-150 ease-in-out"
      >
        Sign Out
      </button>
    </div>
  );
};

export default UserMenuDropdown;
